import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    token: null,
    username: null,
    error: null,
    loading: false,
    message:null,
    id:null,
    authRedirect: false,
    groupId: null,
    groupName: null,
    firstName: null,
    lastName: null,
    employeeId: null,
    uiPermissions: [],
    manager: null,
    involved_groups: [],
    partner: null,
};

const authStart = ( state ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {
    return updateObject( state, { 
        token: action.props.token,
        username: action.props.username,
        id:action.props.id,
        error: null,
        loading: false,
        message:null,
        authRedirect:true,
        groupId: action.props.groupId,
        employeeId: action.props.employeeId,
        groupName: action.props.groupName,    
        firstName: action.props.firstName,    
        lastName: action.props.lastName,
        uiPermissions: action.props.uiPermissions,
        manager:action.props.manager,
        involved_groups: action.props.involved_groups,
        uiFeatures: action.props.uiFeatures,
        processFilter: action.props.processFilter,
        current_task_owner : action.props.current_task_owner ,
        notificationSupport: action.props.notificationSupport,
        profilePhoto: action.props.profilePhoto,
        dashboardView:action.props.dashboardView,
        entityList: action.entity_list,
        entityRoutesMatches: action.entity_routes_match,
        partner: action.props.partner,
     });

};

const authFail = (state, action) => {
    return updateObject( state, {
        message: action.error,
        loading: false
    });
};

const authLogout = (state) => {
    return updateObject(state, { token: null, username: null });
};

const authExpired = (state, action) => {
    return updateObject(state, {
        token: action.token,
     });
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_ERROR: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SESSION_EXPIRED: return authExpired(state, action);
        default:
            return state;
    }
};

export default reducer;